import { render, staticRenderFns } from "./RoadAccesFormDataTable.vue?vue&type=template&id=419b4b91&"
import script from "./RoadAccesFormDataTable.vue?vue&type=script&lang=js&"
export * from "./RoadAccesFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports